import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('OPERATION ROOMS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class OperationRoomsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'operationRooms' como el nombre del recurso a la clase base
    super('operationRooms');
    log.debug('Servicio de Quirofanos inicializado');
  }

}